var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.66671C4.89543 1.66671 4 2.56214 4 3.66671C4 4.77128 4.89543 5.66671 6 5.66671C7.10457 5.66671 8 4.77128 8 3.66671C8 2.56214 7.10457 1.66671 6 1.66671ZM2.66667 3.66671C2.66667 1.82576 4.15905 0.333374 6 0.333374C7.84095 0.333374 9.33333 1.82576 9.33333 3.66671C9.33333 5.50766 7.84095 7.00004 6 7.00004C4.15905 7.00004 2.66667 5.50766 2.66667 3.66671ZM0.976311 9.30969C1.60143 8.68456 2.44928 8.33337 3.33333 8.33337H8.66667C9.55072 8.33337 10.3986 8.68456 11.0237 9.30969C11.6488 9.93481 12 10.7827 12 11.6667V13C12 13.3682 11.7015 13.6667 11.3333 13.6667C10.9651 13.6667 10.6667 13.3682 10.6667 13V11.6667C10.6667 11.1363 10.456 10.6276 10.0809 10.2525C9.70581 9.87742 9.1971 9.66671 8.66667 9.66671H3.33333C2.8029 9.66671 2.29419 9.87742 1.91912 10.2525C1.54405 10.6276 1.33333 11.1363 1.33333 11.6667V13C1.33333 13.3682 1.03486 13.6667 0.666667 13.6667C0.298477 13.6667 0 13.3682 0 13V11.6667C0 10.7827 0.351189 9.93481 0.976311 9.30969Z",
    fill: "#858A97"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.bfa1cc2a.svg";
export { ForwardRef as ReactComponent };